import { composeIO } from 'react-compose-io'
import { fieldsDescricaoNotaFiscalIO } from './FieldsDescricaoNotaFiscal.IO'
import { FieldsDescricaoNotaFiscalView } from './FieldsDescricaoNotaFiscal.View'

export const FieldsDescricaoNotaFiscal = composeIO(FieldsDescricaoNotaFiscalView, fieldsDescricaoNotaFiscalIO)
